import { render, staticRenderFns } from "./ProvincesConfig.vue?vue&type=template&id=0bf225ff&scoped=true"
import script from "./ProvincesConfig.vue?vue&type=script&lang=js"
export * from "./ProvincesConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf225ff",
  null
  
)

export default component.exports